module.exports = __webpack_public_path__ + "img/icon-sports-white.d9c19e13.svg";